 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"admin~app-account~app-card~app-category~app-container~app-helphome~app-menu~app-stacks":"admin~app-account~app-card~app-category~app-container~app-helphome~app-menu~app-stacks","admin~app-container~app-editstack~app-stacks":"admin~app-container~app-editstack~app-stacks","admin~app-container":"admin~app-container","app-container":"app-container","admin~app-editstack":"admin~app-editstack","admin":"admin","app-stacks":"app-stacks","app-account":"app-account","app-card":"app-card","app-category":"app-category","app-helphome":"app-helphome","app-menu":"app-menu","app-editstack":"app-editstack","app-about":"app-about","app-contact":"app-contact","app-getstarted":"app-getstarted","app-home":"app-home","app-premium2":"app-premium2","app-premium~auth":"app-premium~auth","app-premium":"app-premium","auth":"auth","app-subscription":"app-subscription","install":"install","privacy":"privacy","tos":"tos","i-AndroidChrome":"i-AndroidChrome","i-AndroidChromeNoSW":"i-AndroidChromeNoSW","i-AndroidFirefox":"i-AndroidFirefox","i-AndroidOther":"i-AndroidOther","i-AndroidSamsung":"i-AndroidSamsung","i-IOSOther":"i-IOSOther","i-IOSSafari":"i-IOSSafari","i-IOSSafariNoSW":"i-IOSSafariNoSW","i-OtherMobile":"i-OtherMobile","i-PromptInstall":"i-PromptInstall","i-WebDefault":"i-WebDefault"}[chunkId]||chunkId) + "." + {"admin~app-account~app-card~app-category~app-container~app-helphome~app-menu~app-stacks":"ac616279","admin~app-container~app-editstack~app-stacks":"9d771f69","admin~app-container":"43c701a1","app-container":"14b175c0","admin~app-editstack":"75c10326","admin":"029d7953","app-stacks":"764457c0","app-account":"ba252f82","app-card":"55f45c09","app-category":"092688ed","app-helphome":"9003cac9","app-menu":"6386a24c","app-editstack":"d3ad71ce","app-about":"5867ac84","app-contact":"4d2919bf","app-getstarted":"ee28d05a","app-home":"79220412","app-premium2":"f5fd0f22","app-premium~auth":"3afdb09d","app-premium":"b1939a01","auth":"fd6d1a22","app-subscription":"11930966","install":"06e3664f","privacy":"0b935f4c","tos":"5420c372","i-AndroidChrome":"a6f510f8","i-AndroidChromeNoSW":"b4f61a50","i-AndroidFirefox":"94928052","i-AndroidOther":"fa67150b","i-AndroidSamsung":"318153cc","i-IOSOther":"9d6ca9a8","i-IOSSafari":"8a4cd8f0","i-IOSSafariNoSW":"3455a1aa","i-OtherMobile":"86ed8b8f","i-PromptInstall":"6bb35af7","i-WebDefault":"ba694e9e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"admin~app-account~app-card~app-category~app-container~app-helphome~app-menu~app-stacks":1,"admin~app-container~app-editstack~app-stacks":1,"admin~app-container":1,"app-container":1,"admin~app-editstack":1,"admin":1,"app-stacks":1,"app-account":1,"app-card":1,"app-category":1,"app-helphome":1,"app-menu":1,"app-editstack":1,"app-about":1,"app-contact":1,"app-getstarted":1,"app-home":1,"app-premium2":1,"app-premium~auth":1,"app-premium":1,"auth":1,"app-subscription":1,"install":1,"privacy":1,"tos":1,"i-AndroidChrome":1,"i-AndroidChromeNoSW":1,"i-AndroidFirefox":1,"i-AndroidOther":1,"i-AndroidSamsung":1,"i-IOSOther":1,"i-IOSSafari":1,"i-IOSSafariNoSW":1,"i-OtherMobile":1,"i-PromptInstall":1,"i-WebDefault":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"admin~app-account~app-card~app-category~app-container~app-helphome~app-menu~app-stacks":"admin~app-account~app-card~app-category~app-container~app-helphome~app-menu~app-stacks","admin~app-container~app-editstack~app-stacks":"admin~app-container~app-editstack~app-stacks","admin~app-container":"admin~app-container","app-container":"app-container","admin~app-editstack":"admin~app-editstack","admin":"admin","app-stacks":"app-stacks","app-account":"app-account","app-card":"app-card","app-category":"app-category","app-helphome":"app-helphome","app-menu":"app-menu","app-editstack":"app-editstack","app-about":"app-about","app-contact":"app-contact","app-getstarted":"app-getstarted","app-home":"app-home","app-premium2":"app-premium2","app-premium~auth":"app-premium~auth","app-premium":"app-premium","auth":"auth","app-subscription":"app-subscription","install":"install","privacy":"privacy","tos":"tos","i-AndroidChrome":"i-AndroidChrome","i-AndroidChromeNoSW":"i-AndroidChromeNoSW","i-AndroidFirefox":"i-AndroidFirefox","i-AndroidOther":"i-AndroidOther","i-AndroidSamsung":"i-AndroidSamsung","i-IOSOther":"i-IOSOther","i-IOSSafari":"i-IOSSafari","i-IOSSafariNoSW":"i-IOSSafariNoSW","i-OtherMobile":"i-OtherMobile","i-PromptInstall":"i-PromptInstall","i-WebDefault":"i-WebDefault"}[chunkId]||chunkId) + "." + {"admin~app-account~app-card~app-category~app-container~app-helphome~app-menu~app-stacks":"d740277f","admin~app-container~app-editstack~app-stacks":"18468af0","admin~app-container":"0c381468","app-container":"5dc93fcf","admin~app-editstack":"f305ab06","admin":"2bb773f9","app-stacks":"0eb6292e","app-account":"c1476aa0","app-card":"b5e91e30","app-category":"4f4330d1","app-helphome":"5d5a4ea4","app-menu":"aa5ac37c","app-editstack":"1788e690","app-about":"847997b0","app-contact":"1c235530","app-getstarted":"d733a139","app-home":"e6ade6bd","app-premium2":"2dddb6b6","app-premium~auth":"6becd34a","app-premium":"1c235530","auth":"f8c884d2","app-subscription":"571fcf0e","install":"9c322916","privacy":"143f1a07","tos":"143f1a07","i-AndroidChrome":"a5bc68ac","i-AndroidChromeNoSW":"ad2575e4","i-AndroidFirefox":"0bf2f8fd","i-AndroidOther":"ea440dc8","i-AndroidSamsung":"6eb95dc5","i-IOSOther":"eb16137e","i-IOSSafari":"fc48e47a","i-IOSSafariNoSW":"326add24","i-OtherMobile":"040fdb7b","i-PromptInstall":"8ee92fef","i-WebDefault":"9beb7e3e"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	var startupResult = (function() {
 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
 	})();

 	webpackJsonpCallback([[], {}, 0, ["install"]]);
 	return startupResult;
